import registerapi from '../api/registerapi'
import auth from '../api/auth'
import session from '../api/session'
import types from './types'
// import apiurl from '../api/baseurl'

//const firstlogininfo = require('@/assets/firstlogin.json')
const statuses = {
  NOT_STARTED: 'NOT_STARTED',
  SERVER_REGISTRATION_BEGIN: 'SERVER_REGISTRATION_BEGIN',
  SERVER_REGISTRATION_ERR: 'SERVER_REGISTRATION_ERR',
  SERVER_REGISTRATION_OK: 'SERVER_REGISTRATION_OK',
  SUBSCRIPTION_BEGIN: 'SUBSCRIPTION_BEGIN',
  SUBSCRIPTION_ERR: 'SUBSCRIPTION_ERR',
  SUBSCRIPTION_OK: 'SUBSCRIPTION_OK',
  SUBSCRIPTION_NOT_OK: 'SUBSCRIPTION_NOT_OK',
  PREMIUM_CODE_OK: 'PREMIUM_CODE_OK',
  PREMIUM_CODE_NOT_OK: 'PREMIUM_CODE_NOT_OK',
  DOWNLOAD_TERMS_BEGIN: 'DOWNLOAD_TERMS_BEGIN',
  DOWNLOAD_TERMS_ERR: 'DOWNLOAD_TERMS_ERR',
  DOWNLOAD_TERMS_OK: 'DOWNLOAD_TERMS_OK'
}

const initialState = {
  registerConfiguration: null,
  currentStep: 0,
  role: '',
  globalTerms: [],
  productTerms: [],
  globalTermsDownloaded: false,
  productTermsDownloaded: types.EMPTY,
  productTermsStatus: null,
  jobcenters: [],
  specialities: [],
  usefulTerms: [],
  mail: '',
  pass: '',
  professional_number: '',
  user_name: '',
  user_surname: '',
  user_surname2: '',
  doctor_resident_year: 0,
  doctor_resident: false,
  validated: false,
  premiumCode: '',
  validPremiumCode: false,
  serverRegisterResponse: {},
  doctor_title: 'Dra',
  firstLoginInfo: {},
  subscribeInfo: {},
  administrative_area: '',
  doctor_jobcenter: '',
  doctor_jobcenter_other: '',
  doctor_specialty_main: '',
  status: statuses.NOT_STARTED,
  errors: [],
  globalTermsID: [],
  countries: [],
  country: null,
  administrative_areas: [],
  doctor_professional_doc: null
}

const getters = {
  isAuthenticated: state => !!state.token
}

const actions = {
  getProductTerms: context => {
    if (
      context.state.productTermsDownloaded === types.QUERY_OK ||
      context.state.productTermsDownloaded === types.QUERY_BEGIN
    ) {
      return Promise.resolve({})
    }
    context.commit('productTermsDownloaded', types.QUERY_BEGIN)
    const productName =
      context.rootGetters['decoupled/getProperConfig'].productName
    let responsePromise = registerapi.getTermsProduct(productName)
    responsePromise.then(({ data }) => {
      context.commit('productTerms', data)
      context.commit('productTermsDownloaded', types.QUERY_OK)
    })
    return responsePromise
  },
  getGlobalTerms: context => {
    let responsePromise = registerapi.getTermsGlobal()
    responsePromise.then(({ data }) => {
      context.commit('globalTerms', data)
      context.commit('globalTermsDownloaded', true)
    })
    return responsePromise
  },
  register0: (context, { mail, pass, terms }) => {
    const st = context.state

    let responsePromise = auth.createAccount0(
      st.role,
      mail,
      pass,
      terms,
      st.professional_number,
      st.user_name,
      st.user_surname,
      st.user_surname2,
      st.doctor_jobcenter,
      st.doctor_jobcenter_other,
      st.administrative_area,
      st.country.id,
      st.doctor_specialty_main,
      st.doctor_title,
      st.doctor_resident,
      st.doctor_resident_year,
      st.doctor_professional_doc
    )
    //context.commit('cleanCredentials')
    responsePromise.then(({ data }) => {
      context.commit('serverRegisterResponse', data)
    })
    return responsePromise
  },
  login0: (context, { mail, pass, terms }) => {
    let responsePromise = auth.login(mail, pass, terms)
    responsePromise.catch(error => {
      context.commit('firstLoginInfo', error.response.data)
    })
    return responsePromise
  },
  subscribe: (context, isApp) => {
    context.commit('setStatus', statuses.SUBSCRIPTION_BEGIN)
    let productTermsId = []
    context.state.productTerms.forEach(t => {
      productTermsId.push(t.nid)
    })

    let responsePromise = registerapi.subscribe(
      '',
      context.state.firstLoginInfo.requirements.groups[0].id,
      productTermsId,
      isApp
    )
    responsePromise
      .then(({ data }) => {
        //TBD guardar token
        context.commit('subscribeInfo', data)
        if (data[0] == true)
          context.commit('setStatus', statuses.SUBSCRIPTION_OK)
        else context.commit('setStatus', statuses.SUBSCRIPTION_NOT_OK)
      })
      .catch(error => {
        context.commit('setStatus', statuses.SUBSCRIPTION_ERR)
        context.commit('addError', error)
      })
    return responsePromise
  },
  subscribeExistingUser: (context, logininfo) => {
    context.commit('setStatus', statuses.SUBSCRIPTION_BEGIN)
    //let productTermsId=context.state.productTerms.nid
    let acceptedTerms = []
    logininfo.terms.forEach(term => {
      acceptedTerms.push(term.id)
    })
    let responsePromise = registerapi.subscribe(
      context.state.premiumCode,
      logininfo.groupid,
      acceptedTerms
    ) //TODO obtener groupid programaticamente
    responsePromise
      .then(({ data }) => {
        //TBD guardar token
        context.commit('subscribeInfo', data)
        if (data[0] == true)
          context.commit('setStatus', statuses.SUBSCRIPTION_OK)
        else context.commit('setStatus', statuses.SUBSCRIPTION_NOT_OK)
      })
      .catch(error => {
        context.commit('setStatus', statuses.SUBSCRIPTION_ERR)
        context.commit('addError', error)
      })
    return responsePromise
  },
  validateDoctorData: (
    context,
    { professional_number, user_name, user_surname }
  ) => {
    let responsePromise = registerapi.validateDoctorData(
      professional_number,
      user_name,
      user_surname
    )
    responsePromise
      .then(({ data }) => {
        context.commit('validate', data[0])
        if (data == true) {
          context.commit('setStatus', statuses.PREMIUM_CODE_OK)
        }
      })
      .catch(error => {
        context.commit('addError', error)
      })
    return responsePromise
  },
  validatePremiumCode: (context, code) => {
    return registerapi
      .validatePremiumCode(code)
      .then(({ data }) => {
        //context.commit('validPremiumCode',data[0])
        if ('valid' in data.data) {
          if (data.data.valid === true) {
            context.commit('setPremiumCode', { isValid: true, code: code })
            //ontext.commit('validPremiumCode',data[0])
          }
        }
      })
      .catch(error => {
        context.commit('setPremiumCode', { isValid: false, code: '' })
        context.commit('setStatus', statuses.PREMIUM_CODE_NOT_OK)
        context.commit('addError', error)
      })
  },
  validatePremiumCodeAuth: (context, code) => {
    context.commit(
      'setServerCredentials',
      context.rootState.auth.server_credentials
    )
    let validatePromise = registerapi
      .validatePremiumCodeAuth(code)
      .then(({ data }) => {
        //context.commit('validPremiumCode',data[0])
        if ('valid' in data.data) {
          if (data.data.valid === true) {
            context.commit('setPremiumCode', { isValid: true, code: code })
            //ontext.commit('validPremiumCode',data[0])
          }
        }
      })
      .catch(error => {
        context.commit('setPremiumCode', { isValid: false, code: '' })
        context.commit('setStatus', statuses.PREMIUM_CODE_NOT_OK)
        context.commit('addError', error)
      })
    context.commit(
      'setClientCredentials',
      context.rootState.auth.slave_credentials
    )
    return validatePromise
  },
  getCountries: (context) => {
    let responsePromise = registerapi.getCountries()
    responsePromise.then(({ data }) => {
      context.commit('setCountries', data)
    })
    return responsePromise
  },
  getAdministrativeAreas: (context, { country }) => {
    let responsePromise = registerapi.getAdministrativeAreas(country)
    responsePromise.then(({ data }) => {
      context.commit('setAdministraiveAreas', data)
    })
    return responsePromise
  },
  getJobcenters: (context, { administrative_area }) => {
    let responsePromise = registerapi.getJobcenters(administrative_area)
    responsePromise.then(({ data }) => {
      context.commit('setJobcenters', data)
    })
    return responsePromise
  },
  getSpecialities: (context, { country }) => {
    let responsePromise = registerapi.getSpecialities(country)
    responsePromise.then(({ data }) => {
      context.commit('setSpecialities', data)
    })
    return responsePromise
  },
  checkMail: (context, mail) => {
    let promise = registerapi.checkMail(mail)
    promise

    return promise
  },
  getRegisterConfiguration: context => {
    registerapi.getRegisterConfiguration().then(data => {
      console.log(data)
      context.commit('setRegisterConfiguration', data.data)
    })
  }
}

const mutations = {
  nextStep: state => {
    state.currentStep++
  },
  prevStep: state => {
    state.currentStep--
    if (state.currentStep < 0) state.currentStep = 0
  },
  setStep: (state, value) => {
    state.currentStep = value
  },
  setRole: (state, role) => {
    state.role = role
  },
  setCountry: (state, country) => {
    state.country = country
  },
  productTerms: (state, productTermsArray) => {
    productTermsArray.forEach(t => {
      state.usefulTerms.push({ term: t, accept: false })
    })
    state.productTerms = productTermsArray
    //state.usefulTerms.productTerm = productTerm
  },
  globalTerms: (state, termsArray) => {
    termsArray.forEach(t => {
      state.usefulTerms.push({ term: t, accept: false })
    })
    state.globalTerms = termsArray
  },
  globalTermsDownloaded: (state, isdownloaded) => {
    state.globalTermsDownloaded = isdownloaded
  },
  productTermsDownloaded: (state, isdownloaded) => {
    state.productTermsDownloaded = isdownloaded
  },
  setAcceptedTerms: state => {
    state.usefulTerms.forEach(t => {
      t.accept = true
    })
  },
  setStep2: (
    state,
    {
      doctor_title,
      doctor_resident,
      doctor_resident_year,
      professional_number,
      user_name,
      user_surname,
      user_surname2,
      doctor_professional_doc
    }
  ) => {
    state.doctor_title = doctor_title
    state.professional_number = professional_number
    state.user_name = user_name
    state.user_surname = user_surname
    state.user_surname2 = user_surname2
    state.doctor_resident = doctor_resident
    state.doctor_resident_year = doctor_resident_year
    state.doctor_professional_doc = doctor_professional_doc
  },

  setStep3: (
    state,
    {
      doctor_jobcenter,
      doctor_jobcenter_other,
      administrative_area,
      doctor_specialty_main,
    }
  ) => {
    state.doctor_jobcenter = doctor_jobcenter
    state.doctor_jobcenter_other = doctor_jobcenter_other
    state.administrative_area = administrative_area
    state.doctor_specialty_main = doctor_specialty_main
  },
  setStep0: (state, { mail, pass, country }) => {
    state.mail = mail
    state.pass = pass
    state.country = country
  },
  validate: (state, isvalidated) => {
    state.validated = isvalidated
  },
  setCountries: (state, countries) => {
    state.countries = countries
  },
  setAdministraiveAreas: (state, administrative_areas) => {
    state.administrative_areas = administrative_areas
  },
  setJobcenters: (state, jobcenters) => {
    state.jobcenters = jobcenters
  },
  setSpecialities: (state, specialities) => {
    state.specialities = specialities
  },
  serverRegisterResponse: (state, response) => {
    state.serverRegisterResponse = response
  },
  firstLoginInfo: (state, response) => {
    state.firstLoginInfo = response
  },
  subscribeInfo: (state, response) => {
    state.subscribeInfo = response
  },
  setServerCredentials(state, server_credentials) {
    //localStorage.setItem("server_credentials",  JSON.stringify(server_credentials))
    //https://stackoverflow.com/questions/45578844/how-to-set-header-and-options-in-axios
    session.defaults.headers.common['X-CSRF-TOKEN'] =
      server_credentials['X-CSRF-Token']
    session.defaults.headers.common['X-NVDUS'] =
      server_credentials['sessname'] + '=' + server_credentials['sessid']
    //  state.server_credentials = server_credentials
  },
  setClientCredentials(state, client_credentials) {
    //localStorage.setItem("client_credentials",  JSON.stringify(client_credentials))
    //https://stackoverflow.com/questions/45578844/how-to-set-header-and-options-in-axios
    session.defaults.headers.common['X-CSRF-TOKEN'] =
      client_credentials['X-CSRF-Token']
    session.defaults.headers.common['X-NVDUS'] =
      client_credentials['sessname'] + '=' + client_credentials['sessid']
    //  state.server_credentials = server_credentials
  },

  cleanCredentials(/* state */) {
    delete session.defaults.headers.common['X-CSRF-TOKEN']
    delete session.defaults.headers.common['X-NVDUS']
  },

  setStatus: (state, newState) => {
    state.status = newState
  },

  setPremiumCode: (state, { isValid, code }) => {
    state.validPremiumCode = isValid
    state.premiumCode = code
  },
  addError: (state, error) => {
    state.errors.push(error)
  },
  setGlobalTermsID: (state, value) => {
    state.globalTermsID = value
  },
  setRegisterConfiguration: (state, value) => {
    state.registerConfiguration = value
  }
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
  statuses
}
